import { storage } from '@abyss/web/tools/storage';
import { parseSessionCookie } from '../../../../commonUtils/src/sessionManager';

import { SessionCookie } from 'commonUtils/src/sessionManager/dataModels/SessionCookie';

export const FINDCARE_AND_COST_SSO_SESSION_COOKIE: string =
  'FINDCARE_AND_COST_SSO_SESSION';

export const isSessionValid = (cookie: SessionCookie): boolean => {
  const { lastAccessedSecs, durationSecs } = cookie;

  if (lastAccessedSecs && durationSecs) {
    const accessTimeMillis = lastAccessedSecs * 1000;
    const durationMillis = durationSecs * 1000;

    if (new Date().getTime() < accessTimeMillis + durationMillis) {
      return true;
    }
  }
  return false;
};

export const loginNotRequired = (): boolean => {
  const hostname = window?.location?.hostname?.toLowerCase();
  return hostname === 'localhost';
};

export const isInvalidSession = () => {
  const ssoSessionCookie = storage.cookie.get(
    FINDCARE_AND_COST_SSO_SESSION_COOKIE
  );
  const cookie = parseSessionCookie(ssoSessionCookie);

  if (ssoSessionCookie && !isSessionValid(cookie)) {
    return true;
  }
  return false;
};
